import { render, staticRenderFns } from "./ThreeDots.vue?vue&type=template&id=f2bc70a6&scoped=true&"
import script from "./ThreeDots.vue?vue&type=script&lang=js&"
export * from "./ThreeDots.vue?vue&type=script&lang=js&"
import style0 from "./ThreeDots.vue?vue&type=style&index=0&id=f2bc70a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bc70a6",
  null
  
)

export default component.exports